/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgDesktopCode = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path d="M2 2h20v15h-9v3h4v2H7v-2h4v-3H2V2zm2 2v11h16V4H4z" fill="currentcolor" />
      <path
        d="m9.293 5.793 1.414 1.414L8.414 9.5l2.293 2.293-1.414 1.414L5.586 9.5l3.707-3.707zM15.586 9.5l-2.293-2.293 1.414-1.414L18.414 9.5l-3.707 3.707-1.414-1.414L15.586 9.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgDesktopCode as DesktopCode };
